import * as React from 'react'
import { addNoScroll, removeNoScroll } from '../../../utils/overflowHelper'
import { goToMenuOption } from '../../../utils/useMenuOptions'
import { Context } from '../../../context/app-context'
import './layout-college.scss'

export const LayoutCollege = () => {
  const [activeMenu, setActiveMenu] = React.useState(false)
  const [activeOption, setActiveOption] = React.useState()
  const { userInfo } = React.useContext(Context)

  const NAV_OPTIONS = [
    'Participar',
    userInfo ? "Registrar claves" : 'Regístrate',
    '¿Cómo ganar?',
    'Ranking',
    'Premios',
    'Preguntas frecuentes',
    'Términos y condiciones',
  ]

  const formatOption = option =>
    option
      .normalize('NFD')
      .toLowerCase()
      .replace(/\s/g, '0')
      .replace(/[\u0300-\u036f]|\W/gim, '')
      .replace(/0/g, '-')

  const openMenu = () => {
    setActiveMenu(true)
  }

  const closeMenu = () => {
    setActiveMenu(false)
  }

  React.useEffect(() => {
    if (activeMenu) {
      addNoScroll()
    } else {
      removeNoScroll()
    }
  }, [activeMenu])

  return (
    <>
      <div className="f-button-menu">
        <button
          className="f-button-menu__button"
          onClick={openMenu}
          aria-label="open menu"
        >
          <span className="icon-menu f-button-menu__button__icon"></span>
          <p className="f-button-menu__button__label">College</p>
        </button>
      </div>

      <aside
        className={`f-layout-college ${
          activeMenu ? 'f-layout-college--active' : ''
        }`}
      >
        <i
          role="button"
          aria-hidden="true"
          aria-label="close menu"
          className="icon2-close f-layout-college__close-menu"
          onClick={closeMenu}
        />

        <nav className="f-layout-college__nav">
          {NAV_OPTIONS.map((option, index) => {
            let optionFormated = formatOption(option)
            let isActive = optionFormated === activeOption

            return (
              <a
                key={index}
                href={`#${optionFormated}`}
                onClick={e => {
                  window.dataLayer =
                    window.dataLayer || []
                  window.dataLayer.push({
                    'event':'Interacciones - Menú',
                    'category':'cole challenge',
                    'action':'click',
                    'label':`${option}`
                  })
                  e.preventDefault()
                  activeMenu && closeMenu()
                  setActiveOption(optionFormated)
                  goToMenuOption(optionFormated)
                }}
                className={`f-layout-college__nav__option ${
                  isActive ? 'f-layout-college__nav__option--active' : ''
                }`}
              >
                {option}
              </a>
            )
          })}
        </nav>
      </aside>
    </>
  )
}
